import { QueryClient } from '@tanstack/react-query'
import ms from 'ms'

export const DEFAULT_QUERY_STALE_TIME = ms('5 seconds')
export const DEFAULT_QUERY_GC_TIME = ms('20 minutes')

export const defaultQueryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: DEFAULT_QUERY_STALE_TIME,
      gcTime: DEFAULT_QUERY_GC_TIME,
      retry: (failureCount, error) => {
        const code = (error as { code?: number })?.code
        if (typeof code === 'number' && code >= 400 && code < 500) {
          return false
        }
        return failureCount < 2
      },
      retryDelay: attemptIndex => Math.min(1000 * 2 ** attemptIndex, 30000),
    },
  },
})
